import * as React from 'react';
import { MatomoProvider, createInstance } from '@datapunt/matomo-tracker-react';

// 创建Matomo实例
const matomoInstance = createInstance({
  urlBase: 'https://oai.com.cn//monitor/', // Matomo服务器地址
  siteId: 7, // 站点ID
});

// Matomo Provider组件
export const MatomoTrackerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return React.createElement(MatomoProvider, { value: matomoInstance }, children);
};

export { matomoInstance };